import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { shrink } from '@/data/utils/keyUtil';
import { laggyMiddleWare } from '@/data/utils/laggyMiddleWare';
import { customRecentOrders } from 'integration/generated/custom';
import { RecentOrdersResponse } from 'integration/generated/custom/data-contracts';
import useSWR from 'swr';

const NON_REQUEST_INTERVAL_TIME = 30000;

export const RecentOrdersFetcher =
	(pub: boolean) =>
	async (
		storeId: string,
		status: string,
		query: {
			langId: string;
			pageNumber?: number;
			pageSize?: number;
		}
	): Promise<RecentOrdersResponse> => {
		const res = await customRecentOrders(pub).recentOrders(storeId, status, {
			langId: query.langId,
			pageNumber: query.pageNumber,
			pageSize: query.pageSize,
		});
		return res;
	};

export const useRecentOrders = (status?: string, pageNumber?: number, pageSize?: number) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { user } = useUser();
	const { storeId, langId } = getClientSideCommon(settings, router);
	const finalStatus = status ?? 'N,M,A,B,C,R,S,D,F,G,L,W';
	const swrKey = storeId
		? [shrink({ storeId, langId, finalStatus, pageNumber, pageSize, userId: user?.userId })]
		: null;
	const { data, error, isLoading } = useSWR<RecentOrdersResponse>(
		swrKey,
		() =>
			RecentOrdersFetcher(true)(storeId, finalStatus, {
				langId,
				pageNumber,
				pageSize,
			}),
		{
			use: [laggyMiddleWare],
			revalidateOnMount: true,
			dedupingInterval: NON_REQUEST_INTERVAL_TIME,
			revalidateOnFocus: false,
		}
	);

	return {
		data,
		error,
		isLoading,
	};
};
